module.exports = __webpack_public_path__ + "static/img/reservations_widget.8323252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reservations_widget.png
// module id = 377
// module chunks = 0